import React from 'react';


export const useTimeoutResettableState = <T>(ms: number, defaultValue?: T) => {
  const [ value, setValue ] = React.useState(defaultValue);
  const timeoutRef = React.useRef<NodeJS.Timeout>();

  React.useEffect(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(() => {
      setValue(defaultValue);
    }, ms);
  }, [ ms, value, setValue, defaultValue ]);

  return [ value, setValue ] as const;
};
